import React from 'react';
import Button from '@components/Button/Button';
import { useAppContext } from '@context/AppContext';
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import styles from './NoAccess.module.scss'


const NoAccess: React.FC = () => {
    const { dispatch } = useAppContext();
    const { logout } = useKindeAuth();

    const handleLogout = async () => {
        localStorage.removeItem( btoa('editingPatient') )
        await logout();
        dispatch({ type: 'LOGOUT' });
    }
    return (
        <div className={styles.noAccessBox}>
            <h1>Sin acceso</h1>
            <p>
                Su sesión no tiene los permisos necesarios para ver esta sección.<br/>
                Por favor, inicie nuevamente sesión con un usuario que tenga los permisos necesarios.
            </p>

            <Button
                label={ 'Cambiar Usuario' }
                type="primary"
                handleClick={handleLogout }
            />
        </div>
    );
};

export default NoAccess;